import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { EvcSmallBizRoutingModule } from './evc-small-biz-routing.module';
import { BrowserThemeService } from './libs/helpers/browser-theme/browser-theme.service';
import { EvsbFinalInvoiceModule } from './pages/evsb-final-invoice/evsb-final-invoice.module';
import { EvsbMailOfferFormModule } from './pages/evsb-mail-offer-form/evsb-mail-offer-form.module';
import { EvsbProductOverviewModule } from './pages/evsb-product-overview/evsb-product-overview.module';
import { EvsbThankYouMailModule } from './pages/evsb-thank-you-mail/evsb-thank-you-mail.module';
import { EvsbThankYouOutboundModule } from './pages/evsb-thank-you-outbound/evsb-thank-you-outbound.module';
import { EvsbThankYouModule } from './pages/evsb-thank-you/evsb-thank-you.module';
import { EvsbVirtualCheckupModule } from './pages/evsb-virtual-checkup/evsb-virtual-checkup.module';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

@NgModule({
  imports: [
    CommonModule,
    AngularSvgIconModule,
    EvcSmallBizRoutingModule,
    EvsbVirtualCheckupModule,
    EvsbMailOfferFormModule,
    EvsbFinalInvoiceModule,
    EvsbThankYouModule,
    EvsbThankYouMailModule,
    EvsbThankYouOutboundModule,
    EvsbProductOverviewModule,
  ],
  providers: [BrowserThemeService],
})
export class EvcSmallBizModule {}

// Add translation markers
_('modules.evsb.pages.title.thankYou');
_('modules.evsb.pages.title.thankYouMail');
